import { create } from 'zustand';

export const useUiStore = create((set) => ({
  globalLoading: 0,
  online: typeof navigator !== 'undefined' ? navigator.onLine : true,
  storeSelectorOpen: false,
  catalogCardView: 'grid', // 'grid' (original vertical card UI by default) | 'horizontal' (new horizontal card UI)
  // What the clicked card already knows about the product the detail modal is
  // opening ({ id, hasOptions }), so the modal's loading state can be sized for
  // the right layout before the product request returns.
  productModalHint: null,

  startLoading: () => set((s) => ({ globalLoading: s.globalLoading + 1 })),
  stopLoading: () => set((s) => ({ globalLoading: Math.max(0, s.globalLoading - 1) })),

  setOnline: (online) => set({ online }),
  openStoreSelector: () => set({ storeSelectorOpen: true }),
  closeStoreSelector: () => set({ storeSelectorOpen: false }),
  setCatalogCardView: (mode) => set({ catalogCardView: mode }),
  setProductModalHint: (hint) => set({ productModalHint: hint }),
}));
